import axios from "axios";
import router from "../router";
import { RESOLVED_API_URL } from "../config";

// API manzili yagona joydan — src/config.js dan olinadi.
export const API_BASE = RESOLVED_API_URL;

// Yuklangan fayl uchun to'liq URL
export function fileUrl(name) {
  return `${API_BASE}/uploads/${name}`;
}

// Markazlashgan axios instance — har so'rovga JWT token qo'shiladi.
const api = axios.create({
  baseURL: API_BASE,
});

// So'rov interceptor: token bo'lsa Authorization sarlavhasiga qo'shamiz.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Javob interceptor: 401 bo'lsa — sessiya tugagan, login'ga qaytaramiz.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("user");
      if (router.currentRoute.value.name !== "login") {
        router.push({ name: "login" });
      }
    }
    return Promise.reject(err);
  }
);

export default api;
